import { STATUS } from "@/lib/format";

export default function StatusBadge({ status, testId }) {
  const s = STATUS[status] || STATUS.unpaid;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-3 py-1 rounded-full border text-sm font-bold whitespace-nowrap ${s.cls}`}>
      {s.label}
    </span>
  );
}
